export default "__VITE_ASSET__C2VnWJA6__"